import MasterService from "./MasterService";

const AgencyService = {
    ...MasterService,

    approveAgencyDocument(params: object) {
        return this.post('/agency/approveAgencyDocument', params)
    },
    getAgencyList(params: object) {
        return this.post('/agency/getAgencyList', params)
    },
    updateAgencyStatus(params: object) {
        return this.post('/agency/updateAgencyStatus', params)
    },
    addAgency(params: object) {
        return this.post('/agency/addAgency', params)
    },
    addAgencyDocument(params: object) {
        return this.post('/agency/addAgencyWebDocument', params)
    },
    getAgencyDetailData(params: object) {
        return this.post('/agency/getAgencyDetailData', params)
    },
    getInsAgencyDetailData(params: object) {
        return this.post('/agency/getUserDetail', params)
    },
    deleteAgencyDocument(params: object) {
        return this.post('/agency/deleteAgencyDocument', params)
    },
    approveAgency(params: object) {
        return this.post('/agency/approveAgency', params)
    },
    saveAgencyPaymentDetails(params: object) {
        return this.post('/lead/saveAgencyPaymentDetail', params)
    },
    agencyCommentHistory(params: object) {
        return this.post('/agency/agencyCommentHistory', params)
    },
   
    getAllAgencyList(params: any) {
        return this.post('/agency/agencyList', params)
    },
    createAgencyLead(params: any) {
        return this.post('/lead/createAgencyLead', params)
    },
    saveAgencyPartner(params: object) {
        return this.post('/agency/saveAgencyPartner', params)
    },
    getSfaRoleUserList(params: object) {
        return this.post('/agency/sfaRoleUser', params)
    },
    updateAgencyData(params: object) {
        return this.post('/agency/updateAgencyDetail', params)
    },
    deleteAgencyDocumentFile(params: object) {
        return this.post('/agency/deleteAgencyDocument', params)
    },

    getAgencyUsers(params: object) {
        return this.post('/agency/getAgencyUserList', params)
    },
    addAgencyUsers(params: object) {
        return this.post('/agency/addAgencyUsers', params)
    },
    getBulkUploadLogs() {
        return this.post('/agency/auth/getBulkUploadLogs')
    },
    uploadCsv(params: object) {
        return this.post('/agency/auth/uploadCsv', params)
    },
    downloadBulkUploadLogs(params: object) {
        return this.post('/agency/auth/downloadBulkUploadLogs', params)
    },
    getAgencySalesUsers(params: object) {
        return this.post('/agencySalesUser/SalesUserList', params)
    },
    getSalesOfficerList(params:any= {}) {
        return this.post('/agencySalesUser/getSalesOfficerList', params)
    },

}

export default AgencyService;